import React from "react";
import { useSiteData } from "../context/SiteDataContext";

const Services: React.FC = () => {
  const { data } = useSiteData();

  return (
    <>
      <div className="page-header">
        <div className="container">
          <h1>Hizmetlerim</h1>
          <p>
            Profesyonel dijital çözümler ile işinizi büyütmeye yardımcı
            oluyorum
          </p>
        </div>
      </div>

      {/* Web Tasarım */}
      <section className="section">
        <div className="container">
          <div className="about-content">
            <div>
              <span className="hero-badge">Web Tasarım</span>
              <h2 style={{ marginTop: "16px", marginBottom: "20px" }}>
                {data.services.web.title}
              </h2>
              <p style={{ color: "var(--text-medium)", lineHeight: "1.8", marginBottom: "16px" }}>
                {data.services.web.description}
              </p>
              <p style={{ color: "var(--text-medium)", lineHeight: "1.8", marginBottom: "24px" }}>
                React, TypeScript ve modern web teknolojileri kullanarak
                hem görsel açıdan etkileyici hem de performanslı web siteleri
                geliştiriyorum.
              </p>
              <ul className="service-features">
                {data.services.web.features.map((feat, idx) => (
                  <li key={idx}>{feat}</li>
                ))}
              </ul>
            </div>
            <div className="about-image">
              🎨
            </div>
          </div>
        </div>
      </section>

      {/* Sesli Yazıya Çeviri */}
      <section className="section section-light">
        <div className="container">
          <div className="about-content" style={{ direction: "rtl" }}>
            <div style={{ direction: "ltr" }}>
              <span className="hero-badge">Sesli Yazıya Çeviri</span>
              <h2 style={{ marginTop: "16px", marginBottom: "20px", direction: "ltr" }}>
                Dünya Şampiyonu Hassasiyet
              </h2>
              <p style={{ color: "var(--text-medium)", lineHeight: "1.8", marginBottom: "16px", direction: "ltr" }}>
                {data.services.ses.description}
              </p>
              <p style={{ color: "var(--text-medium)", lineHeight: "1.8", marginBottom: "24px", direction: "ltr" }}>
                Daha önce kurumsal firmalar, medya şirketleri ve
                bireysel müşteriler için yüzlerce saat ses kaydı
                çevirdim. Gizlilik ve zamanında teslimat benim
                için en önemli öncelikler.
              </p>
              <ul className="service-features" style={{ direction: "ltr" }}>
                {data.services.ses.features.map((feat, idx) => (
                  <li key={idx}>{feat}</li>
                ))}
              </ul>
            </div>
            <div className="about-image" style={{ direction: "ltr" }}>
              🎙️
            </div>
          </div>
        </div>
      </section>

      {/* Canlı Altyazı */}
      <section className="section">
        <div className="container">
          <div className="about-content">
            <div>
              <span className="hero-badge">Canlı Altyazı</span>
              <h2 style={{ marginTop: "16px", marginBottom: "20px" }}>
                {data.services.canli.title}
              </h2>
              <p style={{ color: "var(--text-medium)", lineHeight: "1.8", marginBottom: "16px" }}>
                {data.services.canli.description}
              </p>
              <p style={{ color: "var(--text-medium)", lineHeight: "1.8", marginBottom: "24px" }}>
                İşitme engelli bireyler için erişilebilirlik
                sağlamanın yanı sıra, yabancı dil katılımcılar
                için de altyazı desteği sunulmaktadır.
              </p>
              <ul className="service-features">
                {data.services.canli.features.map((feat, idx) => (
                  <li key={idx}>{feat}</li>
                ))}
              </ul>
            </div>
            <div className="about-image">
              📺
            </div>
          </div>
        </div>
      </section>

      {/* Çalışılan Kurumlar */}
      <section className="section section-light">
        <div className="container">
          <div className="section-header">
            <h2>Çalışılan Kurumlar</h2>
            <p>Daha önce hizmet verdiğim kurumlar ve referanslarım</p>
          </div>
          <div className="clients-grid">
            <div className="client-card">
              <div className="icon">🏛️</div>
              <h4>TRT</h4>
            </div>
            <div className="client-card">
              <div className="icon">🏢</div>
              <h4>Kurumsal Firmalar</h4>
            </div>
            <div className="client-card">
              <div className="icon">📰</div>
              <h4>Medya Şirketleri</h4>
            </div>
            <div className="client-card">
              <div className="icon">⚖️</div>
              <h4>Hukuk Büroları</h4>
            </div>
            <div className="client-card">
              <div className="icon">🎙️</div>
              <h4>Podcaster'lar</h4>
            </div>
            <div className="client-card">
              <div className="icon">🎓</div>
              <h4>Eğitim Kurumları</h4>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
